var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-10" },
    [
      _c(
        "el-row",
        { staticClass: "p-30 bg-white" },
        [
          _c(
            "el-col",
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: { model: _vm.form, "label-width": "auto" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "小程序Logo：" } },
                    [
                      _c("upload", {
                        attrs: { ratio: "1:1" },
                        model: {
                          value: _vm.form.mini_logo,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "mini_logo", $$v)
                          },
                          expression: "form.mini_logo",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "公众号二维码：" } },
                    [
                      _c("upload", {
                        attrs: { ratio: "1:1" },
                        model: {
                          value: _vm.form.public_code,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "public_code", $$v)
                          },
                          expression: "form.public_code",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "小程序名称：" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请填写小程序名称" },
                        model: {
                          value: _vm.form.mini_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "mini_name", $$v)
                          },
                          expression: "form.mini_name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "客服电话：" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请填写客服电话" },
                        model: {
                          value: _vm.form.service_phone,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "service_phone", $$v)
                          },
                          expression: "form.service_phone",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "客服微信号：" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请填写客服微信号" },
                        model: {
                          value: _vm.form.service_wechat,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "service_wechat", $$v)
                          },
                          expression: "form.service_wechat",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "公司名称：" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请填写公司名称" },
                        model: {
                          value: _vm.form.company_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "company_name", $$v)
                          },
                          expression: "form.company_name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "公司地址：" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请填写公司地址" },
                        model: {
                          value: _vm.form.company_address,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "company_address", $$v)
                          },
                          expression: "form.company_address",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "小程序介绍：" } },
                    [
                      _c("tinymce", {
                        attrs: { height: 300 },
                        model: {
                          value: _vm.form.mini_introduce,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "mini_introduce", $$v)
                          },
                          expression: "form.mini_introduce",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.onSubmit("form")
                            },
                          },
                        },
                        [_vm._v("提交")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }